<script>
import entry from '~/pages/_lang/create-seller-account/entry'
export default entry
</script>
